// extracted by mini-css-extract-plugin
module.exports = {"main-poster":"SpaceDetailsPage_main-poster__9UXrw","overflow-artworks":"SpaceDetailsPage_overflow-artworks__v3_wd"};